import axios from '@/libs/api/axios';
import { SubscribeProductType, SubscribedStoresResponse } from '@/libs/type/interfaces/subscription.interface';
import { CHECK_PRODUCT_IS_SUBSCRIBED, SUBSCRIBED_STORES } from '../constants/url';

/**
 * 해당 상품을 현재 구독중인지 확인합니다.
 * @param productType 구독 상품 타입
 * @returns 구독 여부 (true/false)
 */
export const checkProductIsSubscribed = async (productType: SubscribeProductType) => {
  try {
    const endpoint = CHECK_PRODUCT_IS_SUBSCRIBED(productType);
    const response = await axios.get(endpoint);
    const data = await response.data;
    if (Number(data.status) !== 200) {
      throw new Error(data.message);
    }
    return data.result;
  } catch (error) {
    console.error(error);
  }
};

/**
 * 요청한 병원 목록 중 해당 상품을 현재 구독중인 병원 목록을 조회합니다.
 * @param productType 구독 상품 타입
 * @param storeIds 조회할 병원 ID 목록
 * @returns 구독 중인 병원 ID 목록
 */
export const getSubscribedStores = async (productType: SubscribeProductType, storeIds: number[]) => {
  try {
    const endpoint = SUBSCRIBED_STORES(productType);
    const response = await axios.post(endpoint, { storeIds });
    const data = await response.data;
    if (Number(data.status) !== 200) {
      throw new Error(data.message);
    }
    return data.result as SubscribedStoresResponse;
  } catch (error) {
    console.error(error);
  }
};
